var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-centered-item bg-gray-300 h-screen w-screen"},[_c('span',{staticClass:"text-2xl font-medium"},[_vm._v(" "+_vm._s(_vm.$t('open_task'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }